import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/PageHeader";
import HowItWorksButton from "../../../components/howItWorks/HowItWorksButton";
import Camera from "../../camera/Camera";

const SettingsCameras = () => {
  const { t } = useTranslation();

  return (
    <div className="settings-page-wrapper">
      <PageHeader
        title={t("Sensors")}
        showBackButton={true}
        backRoute="/settings"
        backLabel={t("Back to Settings")}
        helpButton={<HowItWorksButton topic="sensors" />}
      />
      <div className="settings-content-wrapper">
        <div className="settings-list-shell">
          <Camera />
        </div>
      </div>
    </div>
  );
};

export default SettingsCameras;
